import { DownloadOutlined, ExclamationCircleOutlined, ImportOutlined, InfoCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Modal, Row, Space, Table, Tooltip, Upload, message } from "antd";
import React, { useState } from "react";
import * as XLSX from 'xlsx';
import '../../css/importexcel-page.css';
import LoadingBase from "../../components/LoadingBase";
import { importUpdateBaseCost } from "../../services/apis";
import { BASE_URL } from "../../settings/config";
import { useSelector } from "react-redux";

const ImportDataSku = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modal, contextHolder] = Modal.useModal();
    const [loadingImport, setLoadingImport] = useState(false);
    const [mess, setMessage] = useState('');
    const [isShowModalMessage, setIsShowModalMessage] = useState(false);
    const userReducer = useSelector((state) => state.userReducer?.data);
    const columns = [
        {
            title: 'SKU code',
            dataIndex: 'sku_code',
            key: 'sku_code',
            width: 150,
            render: (text, record, index) => <div>
                <a style={{ paddingLeft: 8, paddingRight: 8 }}>{text}</a>
            </div>,
        },
        {
            title: 'Base cost',
            dataIndex: 'base_cost',
            key: 'base_cost',
            render: (text, record, index) => <div>
                <span style={{ paddingLeft: 8, paddingRight: 8 }}>{text}</span>
            </div>,
        },
        
    ]



    const confirm = () => {

        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Bạn có chắc chắn muốn import dữ liệu sku ?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => handleSaveInfo()
        });
    };

    const handleDownloadTemplate = () => {
        const link = BASE_URL + 'files/template_import_basecost.xlsx';
        window.open(link, '_blank');
    }

    const handleSaveInfo = async () => {
        setLoading(true);
        const params = {
            items: data,
            created_by: userReducer?.user_info?.id
        }
        const res = await importUpdateBaseCost(params);
        setLoading(false);
        if (res && res?.status === 1) {
            const updated = res?.data?.updated ?? 0;
            const notFoundArr = Array.isArray(res?.data?.not_found) ? res.data.not_found : [];
            const errorsArr = Array.isArray(res?.data?.errors) ? res.data.errors : [];

            const lines = [
                'Kết quả import:',
                `Tổng updated: ${updated}`,
                notFoundArr.length ? `Số SKU không tìm thầy: ${notFoundArr.length}` : null,
                notFoundArr.length ? `Danh sách mã SKU không tìm thấy: ${notFoundArr.join(', ')}` : null,
                errorsArr.length ? `Tổng SKU lỗi: ${errorsArr.length}` : null,
                errorsArr.length ? `Danh sách SKU lỗi: ${errorsArr.join(', ')}` : null,
            ].filter(Boolean);

            const renderMessage = lines.join('\n');

            setMessage(renderMessage);
            setIsShowModalMessage(true);
            setData([]);
        } else {
            message.warning(res?.msg ?? 'Something went wrong');
        }
    }

    const props = {
        name: 'file',
        accept: '.xlsx,.xls',
        beforeUpload: (file) => {
            console.log('beforeUpload', file);
            setLoadingImport(true);
            setLoading(true);
            let reader = new FileReader();
            reader.onload = function (e) {
                let data = e.target.result;
                let readedData = XLSX.read(data, { type: 'binary' });
                const wsname = readedData.SheetNames[0];
                const ws = readedData.Sheets[wsname];

                /* Limit range to columns A to B */
                const range = XLSX.utils.decode_range(ws['!ref']);
                range.e.c = Math.min(range.e.c, 2); // Limit to column B (index 2)
                ws['!ref'] = XLSX.utils.encode_range(range);

                /* Convert array to json */
                const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
                dataParse?.shift(); // Remove header row
                if (dataParse?.length > 100000) {
                    message.error("Do not exceed 100000 orders");
                    setLoadingImport(false);
                    return;
                } else if (dataParse?.length > 0) {
                    // Convert dataParse to array of objects
                    const formattedData = dataParse.map((row) => ({
                        sku_code: row[0], // Cột A
                        base_cost: row[1], // Cột B
                    })).filter(item => item.sku_code !== ''); // Lọc bỏ các dòng không có sku_code hoặc base_cost
                    setData([...formattedData]); // Cập nhật state với dữ liệu đã format
                } else {
                    message.error("No orders found");
                }

                setLoadingImport(false);
                setLoading(false);
            };
            reader.readAsBinaryString(file);
            return false;
        },
    };

    return (

        <div>
            {
                contextHolder
            }
            <Row className="row-button">
                <Upload {...props} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                    <Tooltip title="Max upload 100000 design/file">
                        <Button
                            type="default"
                            size="middle" block danger
                            icon={<ImportOutlined />}
                            disabled={loadingImport}
                            onClick={() => { }}
                            style={{ paddingLeft: 10, paddingRight: 10 }}
                        >
                            Import Excel
                        </Button>
                    </Tooltip>
                </Upload>
                <Space>
                    <Button
                        type="primary"
                        size="middle"
                        block icon={<SaveOutlined />}
                        disabled={loading || data.length === 0}
                        onClick={confirm}
                        style={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                        Lưu thông tin
                    </Button>
                    <Button
                        size="middle"
                        block icon={<DownloadOutlined />}
                        disabled={loading}
                        onClick={handleDownloadTemplate}
                        style={{ paddingLeft: 10, paddingRight: 10, background: 'green', color: 'white' }}
                    >
                        Dowload template
                    </Button>
                </Space>


            </Row>
            {
                data?.length > 0 ?
                    <div>Total: {data?.length} rows</div> : null
            }

            <Table
                className='table-book custom-table'
                columns={columns}
                dataSource={data}
                style={{ marginTop: 20 }}
                rowClassName={() => 'custom-row'}
                scroll={{ x: 'max-content' }}
                pagination={{
                    showSizeChanger: true,
                    size: 'small'
                }}
                rowKey={(item) => item.id?.toString()}
            />
            <LoadingBase loading={loading} />
            <Modal
                open={isShowModalMessage}
                centered
                footer={[
                    <Button key="submit" type="primary" onClick={() => setIsShowModalMessage(false)}>
                        Close
                    </Button>
                ]}
                closable={false}
            >
                <div>
                    <p className="title-notify">
                        <InfoCircleOutlined style={{
                            color: 'blue',
                        }} /> Notify</p>

                    <span>{mess}</span>

                </div>
            </Modal>
        </div>
    )
}

export default React.memo(ImportDataSku);
